import { IAction, StateStatus } from '../../utils/common';
import * as Types from './types';
import PermissionsEnum from 'constants/permissions';

interface IUserData {
  username: string | null;
  email: string | null;
  id: number | null;
  picture: string | null;
  guid: string | null;
}

type Permissions = {
  [key in PermissionsEnum]: string;
};
export interface IState {
  login: boolean | null;
  status: string | null | undefined;
  roles: Array<number | string> | null;
  token: string | null;
  refreshToken: string | null;
  stayLogin: boolean;
  data: IUserData;
  fetchUserDataStatus: StateStatus | null;
  permissions: Permissions | null;
}

const initialState: IState = {
  login: null,
  status: null,
  roles: null,
  token: null,
  refreshToken: null,
  stayLogin: false,
  fetchUserDataStatus: null,
  data: {
    username: null,
    email: null,
    id: null,
    picture: null,
    guid: null,
  },
  permissions: null,
};

const AuthReducer = (state: IState = initialState, action: IAction): IState => {
  switch (action.type) {
    // AUTHENTICATE
    case Types.LOGIN_TYPE:
      return {
        ...state,
        login: action.status === StateStatus.Success,
        status: action.status,
        ...action.data,
      };
    case Types.LOGOUT_TYPE:
      return {
        // ...state,
        ...initialState,
      };
    case Types.USER_DETAILS_TYPE:
      return {
        ...state,
        login: action.status === StateStatus.Success,
        fetchUserDataStatus: action.status ?? null,
        ...action.data,
      };

    case Types.UPDATE_PICTURE:
      return {
        ...state,
        data: {
          ...state.data,
          picture: action.data,
        },
      };

    case Types.REFRESH_TOKEN_TYPE:
      return {
        ...state,
        ...action.data, //refresh token & token
      };
    default:
      return {
        ...state,
      };
  }
};

export default AuthReducer;
